import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../app/store';
import api from '../../../api/axios';
import TVDisplay from '../components/TVDisplay';

const TVPage: React.FC = () => {
  const { playGameId } = useParams<{ playGameId: string }>();
  const accessToken = useSelector((state: RootState) => state.auth.accessToken);
  const refreshToken = useSelector((state: RootState) => state.auth.refreshToken);
  const [ready, setReady] = useState(false);

  // 새 탭에서 열릴 때 refreshToken으로 accessToken 갱신
  useEffect(() => {
    if (accessToken) {
      setReady(true);
      return;
    }

    if (!refreshToken) {
      setReady(true); // 토큰 없으면 그대로 진행 (에러 표시용)
      return;
    }

    // axios interceptor가 401/403 시 자동으로 token refresh 처리하므로
    // 더미 API 호출로 토큰 갱신 트리거
    api.get('/user/me')
      .then(() => setReady(true))
      .catch(() => setReady(true));
  }, [accessToken, refreshToken]);

  if (!playGameId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-white text-2xl">잘못된 접근입니다.</div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-white text-2xl">인증 중...</div>
      </div>
    );
  }

  return <TVDisplay playGameId={Number(playGameId)} />;
};

export default TVPage;
